import { apiRequest } from 'helpers';
import { FullFlag } from 'types';

// 404: "Flag not found."
// 409: "Candidate already has a flag of that type, so you cannot reassign this flag to it (id: {type_duplicates[0].id})."
export const patchFlagMessage = (flag_id: number, message: string) => {
  return apiRequest<FullFlag>({
    method: 'PATCH',
    path: `/v3/flags/${flag_id}`,
    data: {
      message: message,
    },
  });
};

// 204: NO CONTENT
export const deleteFlag = (flag_id: number) => {
  return apiRequest({
    method: 'DELETE',
    path: `/v3/flags/${flag_id}`,
  });
};
